module.exports = __webpack_public_path__ + "static/media/speechflix-logo-white-hd.f3fa99cc.png";